import { Flex } from "@chakra-ui/layout";
import colors from "resources/theme/colors";
import { formatMoney } from "infra/helpers/number";

interface TableItemRowProps {
  bg: string;
  id: string | undefined;
  breadcrumb: string | undefined;
  nome: string | undefined;
  valor: number | undefined;
  color?: string;
  retencao?: boolean;
  complemento?: string;
}

export default function TableItemRow({
  bg,
  breadcrumb,
  id,
  nome,
  valor,
  color = "black",
  complemento,
  retencao = false,
}: TableItemRowProps) {
  return (
    <Flex
      justifyContent="space-between"
      bg={bg}
      py={3}
      px={2}
      pl={8}
      borderBottomColor={colors.black200}
      borderBottomWidth={1}
      key={id}
    >
      <Flex>
        {breadcrumb} {nome} {complemento ? ` - ${complemento}` : ""}
      </Flex>

      <Flex color={color}>
        {retencao ? "-" : ""}
        {formatMoney(valor)}
      </Flex>
    </Flex>
  );
}
